import type { IDashboardTemplate } from "../types";
import { EFamilyTypes } from "../components/DashboardTemplatesTypes";

const dashboard: IDashboardTemplate = {
    id: "blank",
    empty: true,
    locked: false,
    title: "dashboard.templates.blank.title",
    description: "dashboard.templates.blank.description",
    descriptionLong: "",
    keyMetrics: "",
    sticky: true,
    autoFillUserDomain: true,
    minItems: 1,
    maxItems: 5,
    familyType: EFamilyTypes.Website,
};

export default dashboard;
